import Icon from "components/icon";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Colors } from "theme/colors";

export const StyledSelector = styled.div`
  font-size: 0.9375rem;
  position: absolute;
  display: flex;
  flex-direction: row;
  height: 2.35rem;
  right: 0;
  top: calc(0rem - 1.175rem - 0.62rem);
  gap: 0.5rem;
`;

interface LocaleProps {
  $active: boolean;
}

export const StyledLocale = styled.div<LocaleProps>`
  color: ${Colors.PURPLE};
  cursor: pointer;

  ${(props) =>
    props.$active &&
    css`
      color: ${Colors.BLACK};
      pointer-events: none;
      cursor: default;
    `}
`;

export const StyledIcon = styled(Icon)``;
